import React from 'react';
import CompaniesPage from 'core/views/admin/CompaniesPage';

const Companies = () => <CompaniesPage />;

export default Companies;
